<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { SphIcon } from '@/components/base/icon'
import { X } from 'lucide'
import { useI18n } from '@/composables/i18n';

defineOptions({
    compatConfig: {
        MODE: 3,
    },
})

const { i18n } = useI18n();

export interface Tag {
    class?: HTMLAttributes['class']
    value?: any
    label: string
    deletable?: boolean
}

const props = withDefaults(defineProps<Tag>(), {
    class: '',
    value: null,
    deletable: false,
})

const emit = defineEmits<{
    click: []
    delete: []
}>()

</script>

<template>
    <div
        class="tag"
        :class="[
            {
                deletable: props.deletable,
            },
            props.class,
        ]"
        @click="() => {
            emit('click')

            if (props.deletable) {
                emit('delete')
            }
        }"
    >
        <slot>{{ props.label }}</slot>

        <div
            v-if="props.deletable"
            class="delete-button"
            :aria-label="i18n.t('Tag löschen')"
        >
            <SphIcon
                :icon="X"
                size="xs"
            />
        </div>
    </div>
</template>

<style scoped>
@reference '@/assets/styles/config.css';

.tag{
    @apply relative inline-block rounded-md bg-input border border-input-dark text-input-foreground px-2 py-1 text-xs font-medium leading-tight select-none transition-all duration-200;

    &:hover {
        @apply bg-input-dark/75 border-primary/50 text-primary;

        .delete-button {
            @apply text-primary;
        }
    }

    &.deletable {
        @apply pr-6.5 cursor-pointer;
    }

    .delete-button {
        @apply absolute right-0 top-0 flex items-center justify-center w-7 h-full text-muted-foreground;
    }
}
</style>
